module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"coord-title":"Coordonnées","projection-code":"Projection utilisée","EPSG:32632":"SCR UTM Nord Zone 32","coord-start-title":"Coordonnées de départ","coord-end-title":"Coordonnées d\u0027arrivée","line-length-title":"Longueur"},"de":{}}')
  delete Component.options._Ctor
}
